<template>
  <layout-fullscreen bg="/images/photo-2.jpg">
    <div class="body">
      <template v-if="success">
        <div class="t-center">
          <h1 class="heading h3 t-inverse">Password reset successful.</h1>
          <router-link class="button button--inverse" to="/account/login">Continue to Login</router-link>
        </div>
      </template>

      <template v-else>
        <h1 class="heading h2 t-inverse t-center">
          Reset Password
        </h1>

        <form-base @submit.native.prevent="submit">
          <form-input type="password" label="Password" placeholder="********" v-model="password" :error="hasError('password')" :inverse="true" />
          <form-input type="password" label="Confirm Password" placeholder="********" v-model="password_confirmation" :error="hasError('password')" :inverse="true" />
          <button type="submit" class="button button--inverse">Submit</button>
        </form-base>
      </template>      
    </div>
  </layout-fullscreen>
</template>

<style scoped lang="scss">
  .body {
    max-width: 350px;

    @include min-sm {
      max-width: 450px;
    }
  }
</style>

<script>
  import { backend } from '@/api';
  import form from '@/mixins/form';

  import LayoutFullscreen from '@/layouts/Fullscreen';
  import FormBase from '@/components/FormBase';
  import FormInput from '@/components/FormInput';
  import Navigation from '@/components/Navigation';

  export default {
    name: 'AccountForgotPassword',

    mixins: [form],

    props: {
      token: {
        type: String,
        required: true
      }
    },

    components: {
      LayoutFullscreen,
      FormBase,
      FormInput,
      Navigation,
    },

    data: () => ({
      password: '',
      password_confirmation: '',
    }),

    methods: {
      submit () {
        const { password, password_confirmation, token } = this;

        backend.auth.email.resetPassword({ password, password_confirmation, token })
          .then(({ response }) => this.success = true)
          .catch(({ response }) => {
            this.errors = response.data.messages;
          })
      }
    }
  };
</script>